import React from "react";
import Link from "next/link"; // Import Link from Next.js
import { makeStyles } from "@mui/styles";
import Table from "components/Table/Table.js";

import style from "styles/jss/nextjs-material-kit-pro/pages/componentsSections/contentAreas.js";

const useStyles = makeStyles(style);

export default function Tables() {
  const classes = useStyles();

  // Define the table data with corresponding links
  const tableDataWithLinks = [
    { text: "Analytics", link: "/glossary/web-analytics-glossary" },
    {
      text: "Data Science & Visualization",
      link: "/glossary/web-analytics-glossary",
    },
    { text: "Digital Marketing", link: "/glossary/web-analytics-glossary" },
    { text: "Web Development", link: "/glossary/web-development-glossary" },
  ].map((item) => [
    <Link href={item.link} key={item.text}>
      {item.text}
    </Link>,
  ]);

  const tableHead = [<span style={{ fontWeight: "bold" }}>Categories</span>];

  return (
    <div>
      <Table
        tableHead={tableHead}
        tableData={tableDataWithLinks}
        // Adjust the classes for left alignment, remove or modify if they are for center alignment
        customCellClasses={[classes.textLeft]} // Assuming you have a textLeft class for left alignment
        customClassesForCells={[0]}
        customHeadCellClasses={[classes.textLeft]} // Assuming you have a textLeft class for left alignment
        customHeadClassesForCells={[0]}
      />
    </div>
  );
}
